import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPen,
  faCheck,
} from '@fortawesome/free-solid-svg-icons';

import { TYPE } from 'view/info/StaffView';

import Util from 'service/util';
import ContactList from './ContactList';
import Protected from './Protected';

class StaffRow extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = { selected: false };
  }

  render()
  {
    let s = this.props.staff;
    return (
      <label className="table-row">
        <div className="col-staff-sel">
          <input type="checkbox" checked={this.state.selected}
                onChange={ e=>this.setState({selected: e.target.checked}) } />
        </div>
        <div className="col-staff-active">{ !!s.active && <FontAwesomeIcon icon={faCheck} /> }</div>
        <div className="col-staff-code">{ s.id }</div>
        <div className="col-staff-login" title={Util.getRoleName(s.role)}>
          <Protected when={s.role==='SYSTEM'}>{ s.login_name }</Protected>
        </div>
        <div className="col-staff-name">{ s.display_name }</div>
        { TYPE.OFFICE==this.props.filter
          ?<>
            <Protected allow={['ADMIN']}>
              <div className="col-staff-hkid">{ s.hkid }</div>
            </Protected>
            <div className="col-staff-rank">{ s.c_rank }</div>
            <div className="col-staff-title">{ s.title }</div>
            <div className="col-staff-supervisor" title={s.supervisor}>{ s.supervisor_name }</div>
            <Protected allow={['ADMIN']}>
            <div className="col-staff-salary">{ !!s.salary && Util.nf2(s.salary) }</div>
            <div className="col-staff-al">{ s.al_count }</div>
            </Protected>
          </>
          :<>
            <div className="col-staff-supervisor" title={s.supervisor}>{ s.supervisor_name }</div>
            <div className="col-staff-responsible-area">
              <div className="wkr-locations">
                { s.locations?.map(l =>
                  <div className="wkr-location" key={`${s.id}-${l.srv_dis}${l.srv_loc}`}>
                    <span className="wkr-loc-code">{ `${l.srv_dis}${l.srv_loc}` }</span>
                    <span className="wkr-loc-name" title={`${l.name_zh} ${l.name_en}`.trim()}>{ l.name_zh }</span>
                  </div>
                ) }
              </div>
            </div>
          </>
        }
        <div className="col-staff-employ-date">{ Util.ShortDate(s.employ_dtm) }</div>
        <div className="col-staff-resign-date">{ Util.ShortDate(s.resign_dtm) }</div>
        <div className="col-staff-contact">
          <ContactList contacts={ s.contacts } />
        </div>
        <div className="col-staff-mod-by" title={'更改日期: ' + Util.ShortDate(s.mod_dtm)}>{ s.mod_by }</div>
        <div className="col-staff-btn-grp">
          <Protected allow={['ADMIN']}>
            <button className="btn-edit" title="編輯" onClick={e=>this.props.showEditModal(s)}>
              <FontAwesomeIcon icon={faPen} />
            </button>
          </Protected>
        </div>
      </label>
    );
  }
}

export default StaffRow;
